import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import CopyRight from '../../../components/footer/CopyRight';
import BlogDetailsForm from '../../../components/form/BlogDetailsForm';

const HeaderLandingWebsiteBuilder = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changeBackground);

  return (
    <div className="theme-main-menu sticky-menu theme-menu-seven bg-none">
      <div className="d-flex align-items-center justify-content-between">
        <div className="logo order-lg-1">
          <Link to="/">
            <img
              height="45px"
              width="auto"
              src="images/logo/logo-icon.png"
              alt="brand"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

const PrivacyPolicy = () => {
  return (
    <div className="main-page-wrapper p0 font-gordita">
      <Helmet>
        <title>Spacefix.xyz Limited: Software Development Agency</title>
        <meta
          name="description"
          content="Spacefix.xyz Limited is a dynamic software development agency specializing in custom solutions for businesses."
        />
        <meta
          name="keywords"
          content="software development, custom software, CRM development, website development, Spacefix.xyz Limited, software solutions"
        />
      </Helmet>
      {/* End Page SEO Content */}

      <HeaderLandingWebsiteBuilder />
      {/* End Header */}

      {/* =============================================
            Fancy Hero Two
        ==============================================  */}
      <div className="fancy-hero-five bg-white">
        <img
          src="images/shape/95.svg"
          alt="shape"
          className="shapes shape-one"
        />
        <img
          src="images/shape/96.svg"
          alt="shape"
          className="shapes shape-two"
        />
        <div className="bg-wrapper ">
          <div className="container">
            <div className="col-lg-10 m-auto text-center">
              <h1 className="heading">
                <span>
                  Privacy
                  <img src="images/shape/line-shape-11.svg" alt="" />
                </span>{' '}
                Policy
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* =====================================================
            Feature Blog One
        ===================================================== */}
      <div className="blog-page-bg">
        <div className="shapes shape-one"></div>
        <div className="shapes shape-two"></div>
        <div className="shapes shape-three"></div>
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-lg-12 feature-blog-one width-lg blog-details-post-v1">
              <div className="post-meta">
                <h4>Introduction</h4>
                <p>
                  Welcome to Spacefix.xyz Limited (“we”, “us”, “our”). This
                  Privacy Policy explains how we collect, use, disclose, and
                  safeguard your personal information when you visit or interact
                  with our website https://spacefix.xyz (the “Website”) or use
                  our services. By accessing the Website or using our services,
                  you agree to the terms of this Privacy Policy.
                </p>

                <h4>Information We Collect</h4>
                <div className="mark-text">
                  Personal Information You Provide
                </div>
                <p>
                  We may collect personal information you voluntarily give us
                  when you: Contact us via forms or email, Request services,
                  Register for newsletters, Interact with customer support.
                </p>
                <p>
                  Types of personal information may include: Full name, Email
                  address, Phone number, Company name, Job title, Any other
                  information you choose to provide.
                </p>

                <div className="mark-text">
                  Automatically Collected Information
                </div>
                <p>
                  We may automatically collect information when you visit or use
                  our Website, such as: Device information (e.g., browser type,
                  operating system, IP address), Usage data (pages visited,
                  interaction data), Cookies and tracking technologies.
                </p>

                <h4>How We Use Your Information</h4>
                <p>
                  We use your information for purposes including but not limited
                  to: Providing, maintaining, and improving our Website and
                  services, Responding to your inquiries and requests, Sending
                  administrative information (e.g., updates to policies),
                  Understanding and analyzing how you use our services,
                  Personalizing your experience, Complying with legal
                  obligations.
                </p>

                <h4>Cookies & Tracking Technologies</h4>
                <p>
                  We use cookies and similar technologies to collect information
                  about your browsing behavior and to improve your experience on
                  our Website. You can usually control cookies through your
                  browser settings.
                </p>

                <h4>Disclosure of Your Information</h4>
                <p>
                  We may share your personal information with: Service providers
                  who help us operate the Website and provide services, Third
                  parties where required by law or to protect rights and safety,
                  Business partners if you consent or if such sharing is
                  necessary to deliver services.
                </p>
                <p>
                  We do not sell your personal information to third parties for
                  their own marketing purposes.
                </p>

                <h4>Third-Party Links</h4>
                <p>
                  Our Website may contain links to third-party sites, which are
                  not controlled by us. This Privacy Policy does not apply to
                  those sites, and we encourage you to read their respective
                  policies.
                </p>

                <h4>Children's Privacy</h4>
                <p>
                  Our Website and services are not intended for children under
                  the age of 18, and we do not knowingly collect personal
                  information from minors.
                </p>

                <h4>Data Security</h4>
                <p>
                  We implement reasonable security measures to protect your
                  information. However, no internet transmission or storage
                  method is completely secure.
                </p>

                <h4>Data Retention</h4>
                <p>
                  We retain your personal information only as long as necessary
                  for the purposes outlined in this policy or as required by
                  law.
                </p>

                <h4>Your Rights</h4>
                <p>
                  Depending on your location, you may have rights including but
                  not limited to: Accessing your personal information,
                  Correcting inaccurate data, Requesting deletion of your data,
                  Withdrawing consent where processing is based on consent; To
                  exercise your rights, contact us using the details below.
                </p>

                <h4>Changes to This Privacy Policy</h4>
                <p>
                  We may update this policy from time to time. The updated
                  version will be posted on this page with a revised effective
                  date.
                </p>

                <h4>Contact Us</h4>
                <p>
                  If you have questions about this Privacy Policy or wish to
                  exercise your rights, please contact us.
                </p>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
